<template>
  <el-row class="base-info" :gutter="20" type="flex">
    <el-col v-if="!isScnu" :xs="24" :sm="24" :lg="16" class="course-diagnosis">
      <el-row type="flex">
        <el-col :lg="9" class="count-info flex-column flex-center">
          <div id="course-radar-chart" :style="{ height: '400px' }"></div>
          <div class="tooltip-box">
            <div class="content">
              <el-tooltip class="item" effect="dark" placement="bottom">
                <div slot="content">
                  课程活跃度：课程当前活跃度/最高活跃度
                  <br />
                  课程活动：课程活动数/最高课程活动数
                  <br />
                  学生成绩：课程平均分/100
                  <br />
                  课程资源：课程资源数/最高课程资源数
                  <br />
                  学习完成率：课程平均完成度
                  <br />
                  课程讨论：课程讨论数/最高课程讨论数
                </div>
                <i class="mdi mdi-help-circle-outline"></i>
              </el-tooltip>
            </div>
          </div>
        </el-col>
        <el-col :lg="15" class="rank-info flex-column flex-center">
          <el-row>
            <el-col :xs="12" :sm="8">
              <el-card class="base-rank flex-center-center flex-column">
                <div v-if="courseRankData.activity.rank <= 3" class="rank text-danger">
                  TOP {{ courseRankData.activity.rank }}
                </div>
                <div
                  v-else-if="courseRankData.activity.rank > 3 && courseRankData.activity.rank <= 10"
                  class="rank text-warning"
                >
                  TOP {{ courseRankData.activity.rank }}
                </div>
                <div v-else class="rank">第{{ courseRankData.activity.rank }}名</div>
                <div class="rank-title">
                  活动发布
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="'活动数：' + courseRankData.activity.data"
                    placement="top-start"
                  >
                    <span class="click-rank">&gt;</span>
                  </el-tooltip>
                </div>
              </el-card>
            </el-col>

            <el-col :xs="12" :sm="8">
              <el-card class="base-rank flex-center-center flex-column">
                <div v-if="courseRankData.resource.rank <= 3" class="rank text-danger">
                  TOP {{ courseRankData.resource.rank }}
                </div>
                <div
                  v-else-if="courseRankData.resource.rank > 3 && courseRankData.resource.rank <= 10"
                  class="rank text-warning"
                >
                  TOP {{ courseRankData.resource.rank }}
                </div>
                <div v-else class="rank">第{{ courseRankData.resource.rank }}名</div>
                <div class="rank-title">
                  课程资源
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="'资源数：' + courseRankData.resource.data"
                    placement="top-start"
                  >
                    <span class="click-rank">&gt;</span>
                  </el-tooltip>
                </div>
              </el-card>
            </el-col>
            <el-col :xs="12" :sm="8">
              <el-card class="base-rank flex-center-center flex-column">
                <div v-if="courseRankData.finish_rate.data">
                  <div v-if="courseRankData.finish_rate.data >= 85" class="rank text-danger">
                    优秀
                  </div>
                  <div
                    v-else-if="
                      courseRankData.finish_rate.data >= 70 && courseRankData.finish_rate.data < 85
                    "
                    class="rank text-warning"
                  >
                    良好
                  </div>
                  <div
                    v-else-if="
                      courseRankData.finish_rate.data >= 60 && courseRankData.finish_rate.data < 70
                    "
                    class="rank"
                  >
                    及格
                  </div>
                  <div
                    v-else-if="
                      courseRankData.finish_rate.data >= 0 && courseRankData.finish_rate.data < 60
                    "
                    class="rank"
                  >
                    不及格
                  </div>
                </div>
                <div v-else class="rank">未设置</div>
                <div class="rank-title">
                  学习完成率
                  <span class="click-rank"></span>
                </div>
              </el-card>
            </el-col>
            <el-col :xs="12" :sm="8">
              <el-card class="base-rank flex-center-center flex-column">
                <div v-if="courseRankData.active.rank <= 3" class="rank text-danger">
                  TOP {{ courseRankData.active.rank }}
                </div>
                <div
                  v-else-if="courseRankData.active.rank > 3 && courseRankData.active.rank <= 10"
                  class="rank text-warning"
                >
                  TOP {{ courseRankData.active.rank }}
                </div>
                <div v-else class="rank">第{{ courseRankData.active.rank }}名</div>
                <div class="rank-title">
                  活跃度
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="'访问量：' + courseRankData.active.data"
                    placement="top-start"
                  >
                    <span class="click-rank">&gt;</span>
                  </el-tooltip>
                </div>
              </el-card>
            </el-col>

            <el-col :xs="12" :sm="8">
              <el-card class="base-rank flex-center-center flex-column">
                <div v-if="courseRankData.forum.rank <= 3" class="rank text-danger">
                  TOP {{ courseRankData.forum.rank }}
                </div>
                <div
                  v-else-if="courseRankData.forum.rank > 3 && courseRankData.forum.rank <= 10"
                  class="rank text-warning"
                >
                  TOP {{ courseRankData.forum.rank }}
                </div>
                <div v-else class="rank">第{{ courseRankData.forum.rank }}名</div>
                <div class="rank-title">
                  课程讨论
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="'讨论总数：' + courseRankData.forum.data"
                    placement="top-start"
                  >
                    <span class="click-rank">&gt;</span>
                  </el-tooltip>
                </div>
              </el-card>
            </el-col>

            <el-col :xs="12" :sm="8">
              <el-card class="base-rank flex-center-center flex-column">
                <div v-if="courseRankData.grade.data">
                  <div v-if="courseRankData.grade.data >= 85" class="rank text-danger">优秀</div>
                  <div
                    v-else-if="courseRankData.grade.data >= 70 && courseRankData.grade.data < 85"
                    class="rank text-warning"
                  >
                    良好
                  </div>
                  <div
                    v-else-if="courseRankData.grade.data >= 60 && courseRankData.grade.data < 70"
                    class="rank"
                  >
                    及格
                  </div>
                  <div
                    v-else-if="courseRankData.grade.data >= 0 && courseRankData.grade.data < 60"
                    class="rank"
                  >
                    不及格
                  </div>
                </div>
                <div v-else class="rank">未设置</div>
                <div class="rank-title">
                  学习成绩
                  <span class="click-rank"></span>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="flex-between">
            <div class="flex-column">
              <!-- <div>在本课程健康度得分{{}}，满分{{}}分，整体表现{{}}，具体情况如图所示</div>
              <div>在{{}}方面，{{}}为{{}}，评分达到了{{}}，这部分表现非常突出，请继续保持。</div>
              <div>在{{}}方面，{{}}为{{}}，评分只有{{}}，稍有欠缺，仍待进一步加强。</div> -->
              <div class="performance-grade-text">
                <span>
                  在本课程健康度得分{{ courseBaseInfo.score.toFixed(2) }}，满分60分，整体表现
                </span>
                <span
                  :class="
                    courseBaseInfo.score >= 48
                      ? 'text-danger'
                      : courseBaseInfo.score >= 36
                      ? 'text-warning'
                      : ''
                  "
                >
                  <span v-if="courseBaseInfo.score >= 48">优秀</span>
                  <span v-else-if="courseBaseInfo.score >= 36">良好</span>
                  <span v-else>有待提高</span>
                </span>
                <span>，具体情况如图所示</span>
              </div>
              <div class="diagnosis-text" v-show="maxScoreData.score > 5">
                <div>
                  在{{ maxScoreData.factorName }}方面，{{ maxScoreData.factorDataName }}为{{
                    maxScoreData.data.toString().indexOf('.') == -1
                      ? maxScoreData.data
                      : Number(maxScoreData.data).toFixed(2)
                  }}，评分达到了{{
                    maxScoreData.score.toFixed(2)
                  }}，这部分表现非常突出，请继续保持。
                </div>
              </div>
              <div
                class="diagnosis-text"
                :style="minScoreData.score < 5 ? 'visibility:visible' : 'visibility:hidden'"
              >
                <div>
                  在{{ minScoreData.factorName }}方面，{{ minScoreData.factorDataName }}为{{
                    minScoreData.data.toString().indexOf('.') == -1
                      ? minScoreData.data
                      : Number(minScoreData.data).toFixed(2)
                  }}，评分只有{{ minScoreData.score.toFixed(2) }}，稍有欠缺，仍待进一步加强。
                </div>
              </div>
            </div>
            <div class="flex-align-end">
              <div class="data-range">
                <div>统计范围：{{ courseBaseInfo.time }}</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-col>
    <el-col :xs="24" :sm="24" :lg="isScnu ? 24 : 8">
      <el-row :gutter="10" class="flex-wrap">
        <el-col :sm="isScnu ? 6 : 12" :lg="isScnu ? 4 : 12">
          <el-card class="base-count">
            <div class="flex-between flex-align-center">
              <div class="flex-start count-nums">
                <div class="icon-box flex-center-center primary-box">
                  <i class="mdi mdi-bookmark-multiple-outline text-primary"></i>
                </div>
                <div class="flex-column count">
                  <div class="title">活动数</div>
                  <div class="nums">{{ courseBaseInfo.activity }}</div>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :sm="isScnu ? 6 : 12" :lg="isScnu ? 4 : 12">
          <el-card class="base-count">
            <div class="flex-between flex-align-center">
              <div class="flex-start count-nums">
                <div class="icon-box flex-center-center blue-box">
                  <i class="mdi mdi-map-marker-outline text-blue"></i>
                </div>
                <div class="flex-column count">
                  <div class="title">访问量</div>
                  <div class="nums">{{ courseBaseInfo.access_num }}</div>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :sm="isScnu ? 6 : 12" :lg="isScnu ? 4 : 12">
          <el-card class="base-count">
            <div class="flex-between flex-align-center">
              <div class="flex-start count-nums">
                <div class="icon-box flex-center-center danger-box">
                  <i class="mdi mdi-widgets-outline text-danger"></i>
                </div>
                <div class="flex-column count">
                  <div class="title">资源数</div>
                  <div class="nums">{{ courseBaseInfo.recourse }}</div>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :sm="isScnu ? 6 : 12" :lg="isScnu ? 4 : 12">
          <el-card class="base-count">
            <div class="flex-between flex-align-center">
              <div class="flex-start count-nums">
                <div class="icon-box flex-center-center warning-box">
                  <i class="mdi mdi-comment-text-multiple-outline text-warning"></i>
                </div>
                <div class="flex-column count">
                  <div class="title">讨论区数</div>
                  <div class="nums">{{ courseBaseInfo.forum.all }}</div>
                </div>
              </div>
              <div class="flex-column count-detail">
                <div class="detail-item">话题：{{ courseBaseInfo.forum.discussion }}个</div>
                <div class="detail-item">回帖：{{ courseBaseInfo.forum.post }}个</div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :sm="isScnu ? 6 : 12" :lg="isScnu ? 4 : 12">
          <el-card class="base-count">
            <div class="flex-between flex-align-center">
              <div class="flex-start count-nums">
                <div class="icon-box flex-center-center blue-box">
                  <i class="mdi mdi-format-list-bulleted text-blue"></i>
                </div>
                <div class="flex-column count">
                  <div class="title">题库题目数</div>
                  <div class="nums">{{ courseBaseInfo.question }}</div>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :sm="isScnu ? 6 : 12" :lg="isScnu ? 4 : 12">
          <el-card class="base-count">
            <div class="flex-between flex-align-center">
              <div class="flex-start count-nums">
                <div class="icon-box flex-center-center danger-box">
                  <i class="mdi mdi-account-multiple text-danger"></i>
                </div>
                <div class="flex-column count">
                  <div class="title">学生数</div>
                  <div class="nums">{{ courseBaseInfo.student }}</div>
                </div>
              </div>
              <!-- <div class="flex-column count-detail">
                <div class="detail-item">大组：50个</div>
                <div class="detail-item">回帖：50个</div>
              </div> -->
            </div>
          </el-card>
        </el-col>
        <el-col :sm="isScnu ? 6 : 12" :lg="isScnu ? 4 : 12">
          <el-card class="base-count">
            <div class="flex-between flex-align-center">
              <div class="flex-start count-nums">
                <div class="icon-box flex-center-center success-box">
                  <i class="mdi mdi-book-open-outline text-success"></i>
                </div>
                <div class="flex-column count">
                  <div class="title">作业数</div>
                  <div class="nums">{{ courseBaseInfo.assign }}</div>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :sm="isScnu ? 6 : 12" :lg="isScnu ? 4 : 12">
          <el-card class="base-count">
            <div class="flex-between flex-align-center">
              <div class="flex-start count-nums">
                <div class="icon-box flex-center-center info-box">
                  <i class="mdi mdi-clipboard-text-outline text-info"></i>
                </div>
                <div class="flex-column count">
                  <div class="title">测验数</div>
                  <div class="nums">{{ courseBaseInfo.quiz }}</div>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :sm="isScnu ? 6 : 12" :lg="isScnu ? 4 : 12">
          <el-card class="base-count" style="margin-bottom: 0">
            <div class="flex-between flex-align-center">
              <div class="flex-start count-nums">
                <div class="icon-box flex-center-center primary-box">
                  <i class="mdi mdi-sort-variant text-primary"></i>
                </div>
                <div class="flex-column count">
                  <div class="title">章节数</div>
                  <div class="nums">{{ courseBaseInfo.section.all }}</div>
                </div>
              </div>
              <div class="flex-column count-detail">
                <div class="detail-item">一级：{{ courseBaseInfo.section.first }}个</div>
                <div class="detail-item">二级：{{ courseBaseInfo.section.second }}个</div>
                <div class="detail-item">三级：{{ courseBaseInfo.section.third }}个</div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>
<script>
export default {
  data() {
    return {
      // 基本情况
      isExpired: true,
      courseBaseInfo: { radar: [], forum: {}, group: {}, section: {}, score: 0.0 },
      // 图表
      coursePerformance: 1,
      diagnosisData: {},
      courseRadarChart: null,
      screenWidth: '',
      screenHeight: '',
    }
  },
  computed: {
    isScnu() {
      return process.env.VUE_APP_MODE == 'scnu'
    },
    // 课程健康度雷达图x轴y轴数据
    courseRadarData() {
      let data = []
      let radarArray = this.courseBaseInfo.radar.map(item => {
        let radarIndex = 0
        switch (item.type) {
          case 'active':
            radarIndex = 0
            break
          case 'grade':
            radarIndex = 5
            break
          case 'finish_rate':
            radarIndex = 4
            break
          case 'forum':
            radarIndex = 3
            break
          case 'resource':
            radarIndex = 2
            break
          case 'activity':
            radarIndex = 1
            break
        }
        return {
          radarIndex: radarIndex,
          ...item,
        }
      })
      radarArray = radarArray.sort((a, b) => {
        return a.radarIndex - b.radarIndex
      })
      for (let i of radarArray) {
        data.push(i.score)
      }
      return data
    },
    // 课程排行数据
    courseRankData() {
      let data = {
        active: { score: 0, rank: 0, data: 0 },
        grade: { score: 0, rank: 0, data: 0 },
        finish_rate: { score: 0, rank: 0, data: 0 },
        forum: { score: 0, rank: 0, data: 0 },
        resource: { score: 0, rank: 0, data: 0 },
        activity: { score: 0, rank: 0, data: 0 },
      }

      for (let i of this.courseBaseInfo.radar) {
        switch (i.type) {
          case 'active':
            data['active'] = { score: i.score, rank: i.rank, data: i.data }
            break
          case 'grade':
            data['grade'] = { score: i.score, rank: i.rank, data: i.data }
            break
          case 'finish_rate':
            data['finish_rate'] = {
              score: i.score,
              rank: i.rank,
              data: i.data,
            }
            break
          case 'forum':
            data['forum'] = { score: i.score, rank: i.rank, data: i.data }
            break
          case 'resource':
            data['resource'] = { score: i.score, rank: i.rank, data: i.data }
            break
          case 'activity':
            data['activity'] = { score: i.score, rank: i.rank, data: i.data }
            break
        }
      }
      console.log('data', data)
      return data
    },
    // 健康度评价数据排序
    sortedRankScore() {
      let sortedData = this.courseBaseInfo.radar
      sortedData = sortedData
        .sort((a, b) => {
          return a.score - b.score
        })
        .map(item => {
          let factorName = ''
          let factorDataName = ''

          switch (item.type) {
            case 'active':
              factorName = '课程活跃度'
              factorDataName = '访问量'
              break
            case 'grade':
              factorName = '学生成绩'
              factorDataName = '课程平均分'
              break
            case 'finish_rate':
              factorName = '学习完成率'
              factorDataName = '课程平均完成度'
              break
            case 'forum':
              factorName = '课程讨论'
              factorDataName = '讨论总数'
              break
            case 'resource':
              factorName = '课程资源'
              factorDataName = '资源数'
              break
            case 'activity':
              factorName = '课程活动'
              factorDataName = '活动数'
              break
          }
          return {
            factorName: factorName,
            factorDataName: factorDataName,
            ...item,
          }
        })
      console.log('222', JSON.parse(JSON.stringify(sortedData)))
      return sortedData
    },
    // 健康度评价最高分
    minScoreData() {
      let minData = { data: 0.0, rank: 0, score: 0.0, type: '' }
      for (let i of this.sortedRankScore) {
        if (i.score > 0) {
          minData = i
          break
        }
      }
      return minData
    },
    // 健康度评价最低分
    maxScoreData() {
      let maxData = { data: 0.0, rank: 0, score: 0.0, type: '' }
      return this.sortedRankScore[this.sortedRankScore.length - 1] || maxData
    },
  },

  watch: {
    screenWidth() {
      this.getReSize()
    },
  },
  mounted() {
    this.getCourseBaseApi()
    this.screenWidth = document.body.clientWidth //监听页面缩放
    this.screenHeight = document.body.clientHeight
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
        this.screenHeight = document.body.clientHeight
      })()
    }
  },
  methods: {
    // 获取课程基本信息接口
    async getCourseBaseApi() {
      await this.$store
        .dispatch('course/getCourseBase', {
          course_id: Number(this.$route.query.courseId),
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.courseBaseInfo = res.data
            this.iniCourseRadarChart(this.courseRadarData)
            console.log('333', JSON.parse(JSON.stringify(this.sortedRankScore)))
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 初始化图表
    iniCourseRadarChart(courseRadarData) {
      var chart = this.$echarts.init(document.getElementById('course-radar-chart'))
      var option = {
        tooltip: {
          trigger: 'axis',
        },
        radar: {
          indicator: [
            { name: '课程活跃度', max: 10 },
            { name: '课程活动', max: 10 },
            { name: '课程资源', max: 10 },
            { name: '课程讨论', max: 10 },
            { name: '学习完成率', max: 10 },
            { name: '学生成绩', max: 10 },
          ],
        },
        series: [
          {
            tooltip: {
              trigger: 'item',
              valueFormatter: function (value) {
                return value + '分'
              },
            },
            type: 'radar',
            symbolSize: 7,
            areaStyle: {
              color: 'rgba(50, 131, 246, 0.3)',
            },
            color: 'rgba(50, 148, 246, 1)',
            data: [
              {
                value: courseRadarData,
                name: '课程健康度',
              },
            ],
          },
        ],
      }
      chart.setOption(option)
      this.courseRadarChart = chart
    },
    getReSize() {
      let chartArr = [this.courseRadarChart]
      for (let i = 0; i < chartArr.length; i++) {
        //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
        setTimeout(function () {
          if (chartArr[i]) {
            chartArr[i].resize()
          }
        }, 200)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.base-rank {
  border: none;
  box-shadow: none;
  background-color: #f8fafc;
  white-space: nowrap;
  .click-rank {
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
  }
}
.base-count {
  border: 1px solid rgba(229, 232, 235, 1);
  margin-bottom: 16px;
}
.course-diagnosis {
  background-color: #f8fafc;
  .performance-grade-text {
    font-size: 16px;
    color: #6c757d;
  }
  .diagnosis-text {
    font-size: 16px;
    color: #98a6ad;
    border: 1px solid transparent;
    min-height: 1px;
  }
  .data-range {
    font-size: 14px;
    color: #98a6ad;
    text-align: right;
  }
}
.base-info {
  flex-wrap: wrap;
  .rank-info {
    .card {
      margin-bottom: 0;
    }
    .card-body {
      padding: 18px 16px;
    }
    .rank {
      text-align: center;
      color: #343a40;
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 12px;
    }
    .rank-title {
      text-align: center;
      color: #98a6ad;
      font-size: 14px;
    }
    .rank-img {
    }
  }
  .count-info {
    .card {
      margin-bottom: 12px;
      .card-body {
        padding: 18px 16px;
      }
    }
    .tooltip-box {
      position: relative;
      .content {
        position: absolute;
        right: 0;
        bottom: 35px;
        cursor: pointer;
      }
    }
  }
  .count-nums {
    .count {
      margin-left: 16px;
      .title {
        margin-bottom: 8px;
        font-size: 14px;
        color: #98a6ad;
        line-height: 14px;
      }
      .nums {
        font-size: 14px;
        color: #6c757d;
        line-height: 14px;
      }
    }
    .icon-box {
      width: 44px;
      height: 44px;
      border-radius: 4px;

      .mdi {
        font-size: 22px;
      }
    }
    .primary-box {
      background: rgba(50, 131, 246, 0.15);
    }
    .blue-box {
      background: rgba(102, 88, 221, 0.15);
    }
    .danger-box {
      background: rgba(248, 98, 98, 0.15);
    }
    .warning-box {
      background: rgba(252, 192, 21, 0.15);
    }
    .success-box {
      background: rgba(68, 207, 156, 0.15);
    }
    .info-box {
      background: rgba(67, 190, 225, 0.15);
    }
  }
  .count-detail {
    font-size: 10px;
    color: #98a6ad;
    line-height: 10px;
    .detail-item {
      flex: 1;
      margin-bottom: 3px;
      white-space: nowrap;
    }
  }
}
</style>
